export const STATES = {
  // Hi, I'm an enum!
  disease: 0,
  diseaseGlass: 1,
  bone: 2,
  boneGlass: 3,
  mortality: 4,
  mortalityGlass: 5,
};
